import React, { useState } from 'react'
import { ModalType } from '../../states/modals/ModalType.constants'
import { ModalState } from '../../states/modals/reducer'
import { Modal } from '../../components/Modal'

import { useAppSelector } from '../../hooks/useAppSelector'
import EditSchoolForm from '../Form/EditSchoolForm'
import { IEditSchoolFormFields } from '../../types/SchoolAdmin.types'
import {
  getSchoolById,
  updateSchoolForBasicPlanUser,
} from '../../states/schools/actions'
import { hideModal } from '../../states/modals/actions'

import { Button, ButtonThemeType } from '../../components/Button'
import { ButtonType } from '../../components/Button/ButtonType.constants'
import { useAppDispatch } from '../../hooks/useAppDispatch'

interface IEditSchoolModalProps {}

const EditSchoolModal: React.FC<IEditSchoolModalProps> = () => {
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false)
  const schoolId: string = useAppSelector(
    ({ modals }) => modals?.data?.school?.id
  )
  const dispatch = useAppDispatch()
  const { modalType } = useAppSelector<ModalState>(({ modals }) => modals)

  const [formFields, setFormFields] = useState<IEditSchoolFormFields>({})

  const handleSubmit = (): void => {
    setIsSubmitting(true)
    dispatch(
      updateSchoolForBasicPlanUser(
        schoolId,
        formFields,
        () => {
          dispatch(getSchoolById(schoolId))
        },
        () => {
          dispatch(hideModal())
          setIsSubmitting(false)
        }
      )
    )
  }

  if (modalType !== ModalType.EDIT_SCHOOL) {
    return null
  }

  return (
    <Modal
      header="Edit School"
      footer={
        <Button
          label="Update School"
          theme={ButtonThemeType.PRIMARY}
          type={ButtonType.SUBMIT}
          onClick={handleSubmit}
          disabled={isSubmitting}
          inline
        >
          Update School
        </Button>
      }
    >
      <EditSchoolForm
        onChange={(ff) => setFormFields(ff)}
        formFields={formFields}
        onSubmit={handleSubmit}
        isSubmitting={isSubmitting}
      />
    </Modal>
  )
}

export default EditSchoolModal
